import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect, useState } from "react";  // useState kept for loading flag

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // 即時リセット
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    // スクロール可能な全子要素もリセット
    document.querySelectorAll<HTMLElement>("[data-scroll-container], .overflow-y-auto, .overflow-auto, .overflow-y-scroll").forEach(el => {
      el.scrollTop = 0;
    });
    // 念のため次フレームでも再実行（レンダリング後にずれる場合の保険）
    const raf = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname]);
  return null;
}

function LoadingScreen({ onDone }: { onDone: () => void }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // ロード中はスクロールをロック
    document.body.style.overflow = "hidden";
    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        // ロック解除して必ずトップに戻す
        document.body.style.overflow = "";
        window.scrollTo(0, 0);
        onDone();
      }, 600);
    }, 2000);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, [onDone]);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#ffffff",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        opacity: fadeOut ? 0 : 1,
        transition: "opacity 0.6s cubic-bezier(0.22,1,0.36,1)",
        pointerEvents: "auto",
        touchAction: "none",
      }}
    >
      {/* Logo only */}
      <span
        style={{
          fontFamily: "'Barlow', sans-serif",
          fontWeight: 700,
          fontSize: "clamp(36px, 8vw, 64px)",
          letterSpacing: "0.3em",
          color: "#111111",
          display: "block",
          animation: "claplixLogoIn 1s cubic-bezier(0.22,1,0.36,1) both",
        }}
      >
        CRUPLIX
      </span>

      <style>{`
        @keyframes claplixLogoIn {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}

// Appローディング完了をグローバルに通知する
export let appLoadingDone = false;
export function setAppLoadingDone() { appLoadingDone = true; }

function App() {
  const [loading, setLoading] = useState(true);

  const handleDone = () => {
    setAppLoadingDone();
    setLoading(false);
  };

  return (
    <I18nextProvider i18n={i18n}>
      {loading && <LoadingScreen onDone={handleDone} />}
      <div style={{ opacity: loading ? 0 : 1, transition: "opacity 0.4s ease 0.1s" }}>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </div>
    </I18nextProvider>
  );
}

export default App;
